import React from 'react';
import './PickSkanetrafiken.scss';
import { FormattedMessage } from 'react-intl';
import WrapperBox from 'Components/Shared/WrapperBox/WrapperBox';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

interface IProps {
  venueName: string;
  locationName: string;
  isFreeOfCharge: boolean;
}

const PickSkanetrafiken: React.SFC<IProps> = ({
  venueName,
  locationName,
  isFreeOfCharge,
  children,
}) => (
  <WrapperBox style='pick-skanetrafiken'>
    { isFreeOfCharge ?
      <FormattedText 
        style='title'
        displayName='Gratis resa med Skånetrafiken'
        formattedName='order.skanetrafiken.free.title'
      /> :
      <FormattedText 
        style='title'
        displayName='Skånetrafiken/Kulturbiljett'
        formattedName='order.skanetrafiken.common.title'
      />
    }
    { isFreeOfCharge ?
      <FormattedMessage 
        defaultMessage={
          `Till detta arrangemang ingår gratis resa med Skånetrafiken 
          inom Skåne och tillbaka. Biljetten gäller 3 timmar före och 
          3 timmar efter föreställningen. Ange vilken station du vill 
          åka ifrån och lägg till era fria biljetter med Skånetrafiken. 
          Kontrollera buss och tågtider på Skånetrafikens hemsida.`
        }
        id='order.skanetrafiken.free.text'
        values={ { venueName, locationName } }
      /> :
      <FormattedMessage 
        defaultMessage={
          `Köp din resa med Skånetrafiken och spara 20% på biljettpriset. 
          Biljetten gäller 3 timmar före och 3 timmar efter föreställningen. 
          Skånetrafikens ordinarie villkor gäller.`
        }
        id='order.skanetrafiken.common.text'
        values={ { venueName, locationName } }
      />
    }
    { children }
  </WrapperBox>
);

export default PickSkanetrafiken;


// WEBPACK FOOTER //
// ./src/components/PickSkanetrafiken/PickSkanetrafiken.tsx